import { ApiDashboardSettingsResponse } from '../../../api/core/models';
import { DefaultActionsView } from '../../../model/default-actions-view';
import { BoardSettingsV2 } from '../model';

export function dashboardSettingsToDefaultActionsView(
  dashboardSettings?: ApiDashboardSettingsResponse
): BoardSettingsV2['defaultActionsView'] {
  if (!dashboardSettings?.actionSettingsLayout) {
    return undefined;
  }
  if (dashboardSettings.actionSettingsLayout === 'COLUMN') {
    return DefaultActionsView.Column;
  }
  return DefaultActionsView.List;
}
